import { useEffect } from "react";
import styled from "styled-components";
import useDarkLayout from "../../loyauts/use-dark-layout";

type Props = {}

const Container = styled.div`
    .page-box-content {
        min-height: 50vh;

        padding-bottom: 10vh;
    }
`;

const AdminPageContainer: React.FC<Props> = ({ children }) => {

    useDarkLayout();

    useEffect(() => {
        const root = document.querySelector<HTMLElement>(':root');

        if (root) {
            root.style.fontSize = '16px';

            return () => {
                root.style.fontSize = '';
            }
        }
    }, [])

    return <Container>
        <h1>Panel administratora</h1>
        <div className="page-box">
            <div className="page-box-content">
                {children}
            </div>
        </div>
    </Container>
}

export default AdminPageContainer;
